import * as React from "react";

import { ZAttrMeta } from "../ZAttrMeta";
import { ZAttrValue } from "../ZAttrValue";
import { AttrViewFiles } from "./AttrViewFiles";
import { AttrViewImage } from "./AttrViewImage";
import { AttrViewLink } from "./AttrViewLink";
import { AttrViewLongText } from "./AttrViewLongText";
import { AttrViewText } from "./AttrViewText";

type PropsAttrView = {
  value: ZAttrValue;
  meta: ZAttrMeta;
};

export const AttrView: React.FC<PropsAttrView> = ({ value, meta }) => {
  const comp = meta.view?.component;
  const attrRole = meta.type.name === "strOption" ? meta.type.role : undefined;
  if (comp) {
    switch (comp.type) {
      case "LongText":
        return <AttrViewLongText params={comp} value={value} />;
      case "Link":
        return (
          <AttrViewLink
            component={{
              ...comp,
              role: comp.role ?? attrRole,
            }}
            value={value}
          />
        );
      case "Image":
        return (
          <AttrViewImage attrType={meta.type} component={comp} value={value} />
        );
      case "Files":
        return <AttrViewFiles value={value} />;
      default:
        break;
    }
  }
  const attrType = meta.type;
  if (attrType.name === "strOption") {
    if (attrType.role === "image") {
      return <AttrViewImage attrType={meta.type} value={value} />;
    }
    return (
      <AttrViewLink
        value={value}
        component={{ type: "Link", role: attrRole }}
      />
    );
  }
  if (
    attrType.name === "file" ||
    (attrType.name === "array" && attrType.item?.type.name === "file")
  ) {
    return <AttrViewFiles value={value} />;
  }
  return <AttrViewText value={value} meta={meta} />;
};
